import React, { useState, useEffect } from 'react'

const TemplateEditor = ({ templateId, onSave }) => {
  const [template, setTemplate] = useState(null)
  const [content, setContent] = useState('')
  const [availableContext, setAvailableContext] = useState({})
  const [previewData, setPreviewData] = useState({})
  const [previewHtml, setPreviewHtml] = useState('')
  const [error, setError] = useState(null)

  useEffect(() => {
    if (templateId) {
      fetchTemplate()
    }
  }, [templateId])

  const fetchTemplate = async () => {
    try {
      const response = await fetch(
        `/main/api/document-templates/${templateId}/`
      )
      const data = await response.json()
      setTemplate(data)
      setContent(data.content)
      setAvailableContext(data.available_context)
    } catch (err) {
      setError('Failed to load template')
    }
  }

  const handlePreview = async () => {
    try {
      const response = await fetch(
        `/main/api/document-templates/${templateId}/render_template/`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ context: previewData }),
        }
      )

      const data = await response.json()
      if (response.ok) {
        setPreviewHtml(data.rendered_content)
        setError(null)
      } else {
        setError(data.error || 'Preview failed')
      }
    } catch (err) {
      setError('Failed to generate preview')
    }
  }

  const handleSave = async () => {
    try {
      const response = await fetch(
        `/main/api/document-templates/${templateId}/`,
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            content,
            available_context: availableContext,
          }),
        }
      )

      if (response.ok) {
        onSave && onSave()
        setError(null)
      } else {
        const data = await response.json()
        setError(data.error || 'Save failed')
      }
    } catch (err) {
      setError('Failed to save template')
    }
  }

  if (!template) {
    return <div>Loading...</div>
  }

  return (
    <div className="grid grid-cols-2 gap-4 p-4">
      <div className="space-y-4">
        <div>
          <h2 className="text-lg font-semibold mb-2">Template Editor</h2>
          <textarea
            className="w-full h-96 p-2 border rounded"
            value={content}
            onChange={(e) => setContent(e.target.value)}
          />
        </div>

        <div>
          <h2 className="text-lg font-semibold mb-2">Preview Data</h2>
          <textarea
            className="w-full h-48 p-2 border rounded"
            value={JSON.stringify(previewData, null, 2)}
            onChange={(e) => {
              try {
                setPreviewData(JSON.parse(e.target.value))
                setError(null)
              } catch (err) {
                setError('Invalid JSON in preview data')
              }
            }}
          />
        </div>

        <div className="space-x-2">
          <button
            className="px-4 py-2 bg-blue-500 text-white rounded"
            onClick={handlePreview}
          >
            Preview
          </button>
          <button
            className="px-4 py-2 bg-green-500 text-white rounded"
            onClick={handleSave}
          >
            Save
          </button>
        </div>

        {error && <>error</>}
      </div>

      <div>
        <h2 className="text-lg font-semibold mb-2">Preview</h2>
        <div
          className="border rounded p-4 min-h-96 bg-white"
          dangerouslySetInnerHTML={{ __html: previewHtml }}
        />
      </div>
    </div>
  )
}

export default TemplateEditor
